import { Answer, Question, QuestionType } from "../../../domain/entities/question/Question";

interface QuestionDTO {
  readonly id: string;
  readonly key: string;
  readonly type: QuestionType;
  readonly answers: Answer[];
}

const mapQuestionsDTOtoQuestions = (questionsDTO: QuestionDTO[]): Question[] =>
  questionsDTO.map((question: QuestionDTO) => new Question(question));

export { mapQuestionsDTOtoQuestions };
